export default "__VITE_ASSET__wXTN97Kj__"